import React from 'react';
import { compose } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField } from 'redux-form-material-ui';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';

const styles = theme => ({});

const enhance = compose(
  withStyles(styles),
  withRouter,
  reduxForm({ form: 'changePasswordForm' }),
);

const required = value => (value ? undefined : 'Vyžadováno');
const passwordsMustMatch = (value, allValues) =>
  value !== allValues.newPassword1 ? 'Hesla si neodpovídají' : undefined;

export default enhance(({ classes, handleSubmit, setAddUser, history }) => (
  <form className={classes.form} onSubmit={handleSubmit}>
    <Grid container spacing={24}>
      <Grid item xs={12}>
        <Field
          name="oldPassword"
          type="password"
          component={TextField}
          label="Staré heslo"
          validate={[required]}
        />
      </Grid>
      <Grid item xs={12}>
        <Field
          name="newPassword1"
          type="password"
          component={TextField}
          label="Nové heslo"
          validate={[required]}
        />
      </Grid>
      <Grid item xs={12}>
        <Field
          name="newPassword2"
          type="password"
          component={TextField}
          label="Nové heslo znovu"
          validate={[required, passwordsMustMatch]}
        />
      </Grid>
    </Grid>
    <div style={{ margin: 20 }}>
      <Button type="submit" variant="contained" color="primary" className={classes.submit}>
        Uložit
      </Button>
      <Button variant="contained" color="secondary" onClick={() => history.push('/')}>
        Zrušit
      </Button>
    </div>
  </form>
));



// WEBPACK FOOTER //
// ./src/modules/account/changePasswordForm.js